export default __webpack_public_path__ + "static/media/toggleGray.06f8b646.svg";